import { ValidationInputType } from "@generation/core";
import { AbstractValidation } from "@generation/form";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";

function isValidBsn(bsn) {
  let bsnForValidation = bsn;
  if (/^\d{8}$/.test(bsnForValidation)) {
    bsnForValidation = `0${bsnForValidation}`;
  }
  if (!/^\d{9}$/.test(bsnForValidation)) {
    return false;
  }

  const weights = [9, 8, 7, 6, 5, 4, 3, 2, -1];
  let sum = 0;
  for (let i = 0; i < bsnForValidation.length; i++) {
    sum += bsnForValidation[i] * weights[i];
  }
  return sum % 11 === 0;
}

export class BsnValidation extends AbstractValidation {
  key = "isBsn";
  constructor(private readonly required = true, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    if (!this.required && (value === "" || value === undefined || value === null)) {
      return true;
    }

    return isValidBsn(value as unknown as string);
  };

  defaultMessage = (label: string): string => `'${label}' is ongeldig`;
}
